import { render, staticRenderFns } from "./TableEmpresas.vue?vue&type=template&id=8e849000"
import script from "./TableEmpresas.vue?vue&type=script&lang=js"
export * from "./TableEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports